import moment from 'moment';
import { Module } from 'vuex';
import {
    MAINTENANCE_REPORTS_FETCH_ALL,
    MAINTENANCE_REPORTS_FETCH_BY_DC,
} from '@/modules/reports/maintenance-reports/store/maintenance-reports.actions';
import { SET_MAINTENANCE_REPORTS } from '@/modules/reports/maintenance-reports/store/maintenance-reports.mutations';
import { maintenanceReportRepository } from '@/modules/reports/shared/repositories/maintenance-reports.repository';
import { GET_MAINTENANCE_REPORTS } from '@/modules/reports/maintenance-reports/store/maintenance-reports.getters';

const maintenanceReports: Module<any, any> = {
    namespaced: true,
    state: {
        maintenanceReports: [],
    },
    getters: {
        [GET_MAINTENANCE_REPORTS](state): { id: number; date: Date; name: string }[] {
            let result: { id: number; date: Date; name: string }[] = [];

            try {
                result = state.maintenanceReports.map(item => {
                    const date: Date = moment(item.name.substring(0, 7), 'YYYY-MM').toDate();

                    return {
                        id: date.getTime(),
                        date,
                        name: item.name,
                    };
                });
            } catch (e) {
                // Nada por los momentos
            }

            return result;
        },
    },
    mutations: {
        [SET_MAINTENANCE_REPORTS](state, reports) {
            state.maintenanceReports = reports;
        },
    },
    actions: {
        async [MAINTENANCE_REPORTS_FETCH_ALL]({ state, commit }): Promise<boolean> {
            let result: boolean = false;

            try {
                state.maintenanceReports = [];
                const reports = (await maintenanceReportRepository.getAll()).data;
                commit(SET_MAINTENANCE_REPORTS, reports);
                result = true;
            } catch (e) {
                // Nada por los momentos...
            }

            return result;
        },

        async [MAINTENANCE_REPORTS_FETCH_BY_DC](
            { state, commit },
            location: string,
        ): Promise<boolean> {
            let result: boolean = false;

            try {
                state.maintenanceReports = [];
                const reports = (await maintenanceReportRepository.getAll(location)).data;
                commit(SET_MAINTENANCE_REPORTS, reports);
                result = true;
            } catch (e) {
                // Nada por los momentos...
            }

            return result;
        },
    },
};

export default maintenanceReports;
